import React from "react";
import { useSelector } from "react-redux";

import { Wallet3,MedalStar } from "iconsax-react";
import {Star} from '@material-ui/icons'
import { ROUTE_MY_WALLET, ROUTE_STUDENT, ROUTE_TEACHER } from "../../../routes";

import {
  ProfileLink,
  ProfileLinkIcon,
  ProfileLinkTitle,
  ContainerUserInf,
  UserImage,
  WalletIconContainer,
} from "./styledSideBarProfileComponent";

function SideBarProfileComponent({
  links,
  userName,
  userImage,
  userWallet,
  userPoints,
  handleExit,
}) {
  const userRole = useSelector((state) => state.userDetail.userRole);
  const userRoleRoute = userRole === "student" ? ROUTE_STUDENT : ROUTE_TEACHER;

  return (
    <>
      <ContainerUserInf>
        <UserImage src={userImage} alt="کاربر" />
        <p className="mt-2">{userName}</p>

        <div class="flex flex-row row">
            <Star style={{color:'var(--secondary-color)',width: 'fit-content'}}/>
            <p style={{width: 'fit-content', padding: 0}}> {userPoints} امتیاز </p>
        </div>
        <div
          className={
            "my-3 w-100 d-flex justify-content-center align-items-center flex-column"
          }
        >
          {/* <ProfileLink
            to={`${userRoleRoute}/${ROUTE_MY_WALLET}`}
            activeClassName="active-link"
            className="w-100 d-flex justify-content-center"
          > */}
          <WalletIconContainer>
            <Wallet3 />
          </WalletIconContainer>
          {/* </ProfileLink> */}
          <p className="mt-2">{userWallet} تومان </p>
        </div>
      </ContainerUserInf>
      {links.map((item) => {
        return (
          <ProfileLink
            key={item.link}
            to={`${userRoleRoute}/${item.link}`}
            activeClassName="active-link"
            onClick={() => {
              if (item.exit) {
                handleExit();
              }
            }}
          >
            <ProfileLinkIcon>{item.icon}</ProfileLinkIcon>
            <ProfileLinkTitle>{item.title}</ProfileLinkTitle>
          </ProfileLink>
        );
      })}
    </>
  );
}

export default SideBarProfileComponent;
